import styled from '@emotion/styled'
import { SignalType } from 'api'
import { Locale, Translation } from 'locale'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { ModalContent, ModalFooter, ModalWindow } from 'view/components/panels'
import { ClonedComponentByShowModal } from 'view/shared/modal'
import { TextInputField } from '../../../components/inputs'
import { SelectboxField } from '../../../components/options'
import { createDevSignalAction } from '../../../../api/DevSignalActions'

const Content = styled(ModalContent)`
  height: 10rem;
  width: 35rem;
`

export const PurgeEntityDialog: React.FC<ClonedComponentByShowModal> = ({ onClose }) => {
  const [tradableType, setTradableType] = useState<string | undefined>(undefined)
  const [tradableId, setTradableId] = useState<string>('')
  const dispatch = useDispatch()

  return (
    <ModalWindow title={Locale.translate(Translation.TC_PURGE_ENTITY)}>
      <Content>
        <SelectboxField
          label={'Entity Type'}
          value={tradableType}
          onUpdate={(optionKey: string) => {
            setTradableType(optionKey)
          }}
          optionKeys={['Axe', 'Order', 'Negotiation', 'Deal']}
        />
        <TextInputField label={'Entity Id'} value={tradableId} onUpdate={setTradableId} />
      </Content>
      <ModalFooter>
        <TextButton type={TextButtonType.Secondary} onClick={onClose}>
          {Locale.translate(Translation.TC_BUTTON_CANCEL)}
        </TextButton>
        <TextButton
          type={TextButtonType.Primary}
          disabled={!tradableType || !tradableId}
          onClick={() => {
            tradableType &&
              dispatch(createDevSignalAction(SignalType.PURGE_TRADABLE_ENTITY, undefined, [tradableId], undefined, tradableType))
            onClose?.()
          }}>
          {Locale.translate(Translation.TC_BUTTON_OK)}
        </TextButton>
      </ModalFooter>
    </ModalWindow>
  )
}
